<template>
  <section class="section_work">
    <div class="glow_decoration_work"></div>
    <h2 class="title_h2">КАК МЫ <span class="color_orange">РАБОТАЕМ?</span></h2>
    <div class="section_container_work">
      <div class="container_work">
        <div class="box_work_big">
          <div class="contante_work">
            <p class="title_contante_work">
              Заказ <br />
              <span class="color_orange">звонка</span>
            </p>
            <p class="pseudo_text">01</p>
          </div>
          <div class="contante_work">
            <p class="title_contante_work">
              Выезд <br />
              <span class="color_orange">специалиста</span>
            </p>
            <p class="pseudo_text">02</p>
          </div>
          <div class="contante_work">
            <p class="title_contante_work">
              Разработка <br />
              <span class="color_orange">дизайн-проекта</span>
            </p>
            <p class="pseudo_text">03</p>
          </div>
        </div>
        <div class="line_work"></div>

        <div class="box_work_big">
          <div class="box_work_small">
            <p class="small_text_works">Обсуждение ваших пожеланий, заложенного бюджета, наши рекомендации.</p>
          </div>
          <div class="box_work_small">
            <p class="small_text_works"> Консультация и выбор материалов, проведение замера помещения. </p>
          </div>
          <div class="box_work_small">
            <p class="small_text_works">3D моделирование, расчет стоимости.</p>
          </div>
        </div>
      </div>
      <div class="container_work">
        <div class="box_work_big">
          <div class="contante_work">
            <p class="title_contante_work">
              Согласование <br />
              <span class="color_orange">проекта</span>
            </p>
            <p class="pseudo_text">04</p>
          </div>
          <div class="contante_work">
            <p class="title_contante_work">
              Запуск заказа <br />
              <span class="color_orange">в работу</span>
            </p>
            <p class="pseudo_text">05</p>
          </div>
          <div class="contante_work">
            <p class="title_contante_work">
              Доставка и установка<br />
              <span class="color_orange">вашей мебели</span>
            </p>
            <p class="pseudo_text">06</p>
          </div>
        </div>
        <div class="line_work"></div>

        <div class="box_work_big">
          <div class="box_work_small">
            <p class="small_text_works">
              Редактирование, подписание договора, внесение предоплаты.
            </p>
          </div>
          <div class="box_work_small">
            <p class="small_text_works">
              Прорисовка технических чертежей мебели инженером-конструктором и
              изготовление на производстве.
            </p>
          </div>
          <div class="box_work_small">
            <p class="small_text_works">
              Бережная транспортировка в удобное для вас время и
              профессиональная сборка.
            </p>
          </div>
        </div>
      </div>
      <div class="container_work_mobil">
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Заказать<br />
              <span class="color_orange">звонок</span>
            </p>
            <p class="pseudo_text">01</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">Обсуждение ваших пожеланий</p>
          </div>
        </div>
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Выезд <br />
              <span class="color_orange">специалиста</span>
            </p>
            <p class="pseudo_text">02</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">
              Консультация и выбор материалов, проведение замера помещения.
            </p>
          </div>
        </div>
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Разработка <br />
              <span class="color_orange">дизайн-проекта</span>
            </p>
            <p class="pseudo_text">03</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">3D моделирование, расчет стоимости.</p>
          </div>
        </div>
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Согласование <br />
              <span class="color_orange">проекта</span>
            </p>
            <p class="pseudo_text">04</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">
              Редактирование, подписание договора, внесение предоплаты.
            </p>
          </div>
        </div>
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Запуск заказа <br />
              <span class="color_orange">в работу</span>
            </p>
            <p class="pseudo_text">05</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">
              Прорисовка технических чертежей мебели инженером-конструктором и
              изготовление на производстве.
            </p>
          </div>
        </div>
        <div class="box_work_mobil">
          <div class="contante_work">
            <p class="title_contante_work">
              Доставка и <br />
              <span class="color_orange">установка мебели</span>
            </p>
            <p class="pseudo_text">06</p>
          </div>
          <div class="line_work_mobil"></div>
          <div class="box_work_small">
            <p class="small_text_works">
              Бережная транспортировка в удобное для вас время и
              профессиональная сборка.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.container_work_mobil {
  display: none;
}
.section_work {
  height: 47rem;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 6rem 8rem 8rem 8rem;
  gap: 3rem;
  justify-content: flex-end;
}
.glow_decoration_work {
  position: absolute;
  left: -25.85rem;
  top: 20rem;
  width: 81.9rem;
  height: 81.9rem;
  filter: blur(35rem);
  background: rgb(245, 160, 62);
  opacity: 0.2;
  border-radius: 100%;
  z-index: -1;
}
.title_h2 {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 0%;
  text-align: left;
  color: rgb(255, 255, 255);
}

.container_work {
  display: flex;
  flex-direction: column;
  /* gap: 5.5rem; */
}
.contante_work {
  position: relative;
  display: flex;
  width: 12.8rem;
  height: 7.5rem;
  justify-content: flex-start;
  align-items: center;
}
.title_contante_work {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
}
.pseudo_text {
  position: absolute;
  right: 0px;
  top: 0px;
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 6.4rem;
  font-weight: 700;
  line-height: 7.5rem;
  letter-spacing: 0%;
  text-align: left;
  opacity: 0.15;
}
.box_work_big {
  display: flex;
  gap: 13rem;
  justify-content: flex-end;
}
.line_work {
  width: 100%;
  border-bottom: 0.05rem solid rgb(255, 255, 255);
}
.small_text_works {
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  margin-top: 0.6rem;
  width: 12.8rem;
}

.section_container_work {
  display: flex;
  flex-direction: column;
  gap: 5.5rem;
}
@media (max-width: 767px) {
  .section_work {
    padding: 1.7rem 2.4rem 4rem 2.4rem;
    height: fit-content;
  }
  .container_work {
    display: none;
  }
  .container_work_mobil {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  .box_work_mobil {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .contante_work {
    width: 16.43rem;
    justify-content: flex-start;
    align-items: center;
  }
  .line_work_mobil {
    width: 100%;
    border-bottom: 0.07rem solid rgb(255, 255, 255);
  }
  .small_text_works {
    width: 16.43rem;
    font-family: Roboto;
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
  }
  .box_work_small {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }
  .glow_decoration_work {
    width: 60.14rem;
    height: 60.14rem;
    top: 10rem;
    left: -35.71rem;
  }
}
</style>
